import React from 'react'
import styles from 'css/pages/student-live.module.css'
import { BlueButton } from 'components/blue-button'

/* Terminal connection states get honest messages instead of the old
   infinite "Connecting..." spinner (WS-5/WS-7/err-6). Kept separate from
   components/presentation-status-page.tsx: that module's shared primitive
   is icon+blueText+blackText with no action button, and these two views
   carry bespoke copy plus (one of them) a Refresh button -- a shape that
   primitive doesn't offer. */

export const EvictedView = () => (
	<div className={styles.questionContent} style={{ textAlign: 'center' }}>
		<h2>This lesson is open somewhere else</h2>
		<p style={{ fontSize: '18px' }}>You joined from another tab or device, so this one stopped.<br />Close this tab and keep working there.</p>
	</div>
)

export const UnreachableView = () => (
	<div className={styles.questionContent} style={{ textAlign: 'center' }}>
		<h2>We can't reach the classroom</h2>
		<p style={{ fontSize: '18px' }}>Check your internet, then refresh this page.<br />If it keeps happening, tell your teacher.</p>
		<BlueButton label="Refresh" onClick={() => window.location.reload()} />
	</div>
)
